var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-cal',{attrs:{"time":false,"hide-weekends":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }